export const MapboxStyleEnum = {
    CIRCLE_RADIUS: 'circle-radius',
    CIRCLE_STROKE_COLOR: 'circle-stroke-color',
    CIRCLE_STROKE_OPACITY: 'circle-stroke-opacity',
    CIRCLE_COLOR: 'circle-color',
    CIRCLE_STROKE_WIDTH: 'circle-stroke-width',
    LINE_OPACITY: 'line-opacity',
    CIRCLE_OPACITY: 'circle-opacity'
}